import axios from "axios";
import {LOGIN_URL} from "./common";

export const getAccountProfile = async () => {
    try {
        const response = await axios.get(`/account/profile`);
        return response.data;

    } catch (error) {
        console.error('Error account profile:', error);
        return null;
    }
};
export const getNewConversationsCount = async () => {
    try {
        const response = await axios.get(`/conversation/unread`);
        return response.data;
    } catch (error) {
        console.error('Error get new message count:', error);
        return null;
    }
};
export const getConversationFilterCount = async () => {
    try {
        const response = await axios.get(`/conversation/numbers`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get new message count:', error);
        return null;
    }
};
export const getConversationByFilter = async ({status, page}) => {
    try {
        const response = await axios.get(`/conversation/own?status=${status}&page=${page}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get new message count:', error);
        return null;
    }
};
export const getConversationDetails = async (conversationId, page) => {
    try {
        const response = await axios.get(`/conversation/${conversationId}?page=${page}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get new message count:', error);
        return null;
    }
};
export const patchConversationArchive = async (conversationId) => {
    try {
        const response = await axios.patch(`/conversation/${conversationId}/archive`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get new message count:', error);
    }
};
export const patchConversationRead = async (conversationId) => {
    try {
        const response = await axios.patch(`/conversation/${conversationId}/read`);
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error get new message count:', error);
        return null;
    }
};

export const patchConversationUnread = async (conversationId) => {
    try {
        const response = await axios.patch(`/conversation/${conversationId}/unread`);
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error get new message count:', error);
        return null;
    }
};


export const postConversationAccountAdd = async (conversationId, account_id) => {
    try {
        const response = await axios.post(`/conversation/${conversationId}/account/add?account_id=${account_id}`);
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error get new message count:', error);
        return null;
    }
};
export const postReportConversation = async (conversationId, payload) => {
    try {
        const response = await axios.post(`/conversation/${conversationId}/report`, payload);
        return response.data;
    } catch (error) {
        console.error('Error get new message count:', error);
        return null;
    }
};
export const deleteConversationAccountDelete = async (conversationId, account_id) => {
    try {
        const response = await axios.delete(`/conversation/${conversationId}/account/delete?account_id=${account_id}`);
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error get new message count:', error);
        return null;
    }
};
export const getBrokerFilterVendors = async (term) => {
    try {
        const response = await axios.get(`/vendor/filter?term=${term}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error broker search vendor:', error);
        return null;
    }
};
export const getVendorAccounts = async (vendorId) => {
    try {
        const response = await axios.get(`/vendor/${vendorId}/accounts`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error vendor accounts:', error);
        return null;
    }
};
export const getConversationVendorAccounts = async (conversationId) => {
    try {
        const response = await axios.get(`/conversation/${conversationId}/vendors`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error vendor accounts:', error);
        return null;
    }
};
export const postBrokerConversationStart = async (payload) => {
    try {
        const response = await axios.post(`/conversation/start`, payload);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error start conversation:', error);
        return null;
    }
};
export const postConversationMessage = async (conversationId, payload) => {
    try {
        const response = await axios.post(`/conversation/${conversationId}/message/send`, payload);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error start conversation:', error);
        return null;
    }
};

export const putConversationAccountsSync = async (conversationId, payload) => {
    try {
        const response = await axios.put(`/conversation/${conversationId}/accounts/sync`, payload);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error start conversation:', error);
        return null;
    }
};
export const getConversationFiles = async (conversationId, location) => {
    try {
        const response = await axios.get(`/conversation/${conversationId}/filepath?location=${location}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get conversation files:', error);
        return null;
    }
};
export const uploadConversationFile = async (formData) => {
    try {
        const response = await axios.post('/conversation/file/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error uploading file:', error);
        return null;
    }
};

export const deleteConversationFile = async (location) => {
    try {
        const response = await axios.delete(`/conversation/file/delete?location=${location}`);
        return response.data;
    } catch (error) {
        console.error('Error delete conversation file:', error);
        return null;
    }
};
